// Select all the tabs and close buttons
const tabs = document.querySelectorAll('.block-card-modal-tab');
const closeButtons = document.querySelectorAll('.c-btn--close');
let isClickOutsideListenerAdded = false;

// Function to set a tab as active and remove active state from others
function setActiveTab(tab) {
	tabs.forEach((t) => t.classList.remove('active'));
	tab.classList.add('active');

	if (!isClickOutsideListenerAdded) {
		// Delay the adding of the click listener to allow the current click to complete
		document.addEventListener('click', handleClickOutside);
		isClickOutsideListenerAdded = true;
	}
}

// Function to close the active tab
function closeActiveTab() {
	tabs.forEach((t) => t.classList.remove('active'));
	removeClickOutsideListener();
}

function handleClickOutside(event) {
	let blockTabStandard;

	if (event.target) {
		blockTabStandard = event.target.closest('.block-tab-standard');
	}

	if (blockTabStandard) {
		return;
	}
	const activeTab = document.querySelector('.block-card-modal-tab.active');

	if (activeTab && !activeTab.contains(event.target)) {
		closeActiveTab();
	}
}

// Function to remove the click outside listener
function removeClickOutsideListener() {
	if (isClickOutsideListenerAdded) {
		document.removeEventListener('click', handleClickOutside);
		isClickOutsideListenerAdded = false;
	}
}

// Add click event listener to each tab
tabs.forEach((tab) => {
	tab.addEventListener('click', (event) => {
		event.stopPropagation();
		// If the clicked tab is already active, do nothing
		if (tab.classList.contains('active')) return;
		// Set the clicked tab as active and deactivate others
		setActiveTab(tab);
	});
});

// Add click event listener to each close button
closeButtons.forEach((button) => {
	button.addEventListener('click', (event) => {
		event.stopPropagation(); // Prevent click from bubbling up to tab
		closeActiveTab();
	});
});

// Select all elements with `--column_width: 6` in their style attribute
const columns = document.querySelectorAll(
	'.block-content-modal-section [style*="--column_width: 6"]'
);
columns.forEach((column) => {
	// Find all .block-column elements within each column
	const blockColumns = column.querySelectorAll('.block-column');

	blockColumns.forEach((blockColumn) => {
		// Find all <p> elements that are direct children of .block-column
		const paragraphs = Array.from(
			blockColumn.querySelectorAll(
				':scope > p, :scope > .wp-block-heading'
			)
		);

		if (paragraphs.length > 0) {
			// Create a new div element to wrap the <p> tags
			const wrapperDiv = document.createElement('div');

			// Move each <p> tag to the new wrapper div
			paragraphs.forEach((paragraph) => {
				wrapperDiv.appendChild(paragraph);
			});

			// Insert the new wrapper div after the <figure> element
			const figureElement = blockColumn.querySelector('figure');
			if (figureElement) {
				figureElement.insertAdjacentElement('afterend', wrapperDiv);
			} else {
				// If there's no <figure>, just append the wrapperDiv to .block-column
				blockColumn.appendChild(wrapperDiv);
			}
		}
	});
});
